import React, { forwardRef, useImperativeHandle, useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import { API_URL } from "../../../utils/Common";

const initForm = Object.freeze({
   variedadId: "0",
   colorId: "0",
});

const ModalEditarVarColor = forwardRef((props, ref) => {
   const { fn } = props;
   const [tipoFlor, setTipoFlor] = useState({});
   const [variedades, setVariedades] = useState([]);
   const [colores, setColores] = useState([]);
   const [form, setForm] = useState(initForm);

   useEffect(() => {
      console.log(tipoFlor);
      setForm({ variedadId: tipoFlor.variedadesId, colorId: tipoFlor.colorId });
      axios.get(API_URL + "/getVariedadesColores", { params: { tipoFlorId: tipoFlor.florId } }).then((r) => {
         console.log(r.data);
         setVariedades(r.data.variedades);
         setColores(r.data.colores);
      });
   }, [tipoFlor]);

   const onChange = (e) => {
      setForm({
         ...form,
         [e.target.name]: e.target.value,
      });
   };

   const editar = () => {
      console.log(form);
      axios
         .post(API_URL + "/updateTipoFlor", { ...form, tipoFlorId: tipoFlor.id })
         .then((r) => {
            console.log(r.data);
            fn();
            toggleModal();
         })
         .catch((e) => console.log(e));
   };

   //region -- Acciones del Modal
   let openmodal = document.querySelectorAll(".modal-open");
   for (let i = 0; i < openmodal.length; i++) {
      openmodal[i].addEventListener("click", function (event) {
         event.preventDefault();
         toggleModal();
      });
   }

   document.onkeydown = function (evt) {
      evt = evt || window.event;
      let isEscape = false;
      if ("key" in evt) {
         isEscape = evt.key === "Escape" || evt.key === "Esc";
      } else {
         isEscape = evt.keyCode === 27;
      }
      if (isEscape && document.body.classList.contains("modal-active")) {
         toggleModal();
      }
   };

   function toggleModal() {
      const body = document.querySelector("body");
      const modal = document.querySelector("#edvarcol");
      modal.classList.toggle("opacity-0");
      modal.classList.toggle("pointer-events-none");
      body.classList.toggle("modal-active");
   }

   useImperativeHandle(ref, () => ({
      showModal() {
         toggleModal();
      },
      hideModal() {
         toggleModal();
      },
      tipoFlor(tf) {
         setTipoFlor(tf);
      },
   }));
   //endregion

   return (
      <div
         id="edvarcol"
         className="modal opacity-0 pointer-events-none fixed w-full h-full top-0 left-0 flex items-center justify-center"
      >
         <div className="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"></div>
         <div className="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto">
            <div className="modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm z-50">
               <svg
                  className="fill-current text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
               >
                  <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
               </svg>
               <span className="text-sm">(Esc)</span>
            </div>

            <div className="modal-content text-left p-0">
               <div className="flex justify-between items-center pb-3 px-0 bg-orange-900">
                  <p className="text-xl font-bold text-white px-4 py-2">
                     Editar {tipoFlor.flor} {tipoFlor.variedad} {tipoFlor.color}
                  </p>
               </div>
               {/** CONTENIDO */}
               <div className="w-full m-1">
                  <form>
                     <div className="text-sm flex flex-wrap mb-2">
                        <div className="w-1/2 px-3">
                           <label className="block tracking-wide text-gray-700 font-bold mb-2">Variedad:</label>
                           <div className="relative">
                              <select
                                 className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                 name="variedadId"
                                 onChange={onChange}
                                 value={form.variedadId}
                              >
                                 <option value="0">Ninguno</option>
                                 {variedades.map((v, i) => {
                                    return (
                                       <option key={i} value={v.id}>
                                          {v.nombre}
                                       </option>
                                    );
                                 })}
                              </select>
                              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                 <svg
                                    className="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                 >
                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                 </svg>
                              </div>
                           </div>
                        </div>
                        <div className="w-1/2 px-3">
                           <label className="block tracking-wide text-gray-700 font-bold mb-2">Color:</label>
                           <div className="relative">
                              <select
                                 className="block text-sm appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                 name="colorId"
                                 onChange={onChange}
                                 value={form.colorId}
                              >
                                 <option value="0">Ninguno</option>
                                 {colores.map((c, i) => {
                                    return (
                                       <option key={i} value={c.id}>
                                          {c.color}
                                       </option>
                                    );
                                 })}
                              </select>
                              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                 <svg
                                    className="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                 >
                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                 </svg>
                              </div>
                           </div>
                        </div>
                     </div>
                  </form>
               </div>

               {/** ./CONTENIDO */}
               <div className="flex justify-end pt-2 pb-3 mt-2 px-4">
                  <button
                     className="modal-close px-3 bg-white py-2 rounded text-sm text-orange-900 border border-orange-900 hover:bg-orange-100 focus:outline-none"
                     onClick={toggleModal}
                  >
                     Cerrar
                  </button>
                  <button
                     className="px-3 bg-orange-900 py-2 rounded text-sm text-white hover:bg-orange-800 ml-2 focus:outline-none"
                     onClick={editar}
                  >
                     Editar
                  </button>
               </div>
            </div>
         </div>
      </div>
   );
});

export default ModalEditarVarColor;
